import React, { useEffect, useState } from 'react';
import { CostosAñoAdapter } from '../../../../../infraestructure/persistence/rest/CostosAñoAdapter';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import ComboEjercicios from './combo';
import { useNotifications } from '../../../../../shared/hooks/Notifications';

export const ComboEjerciciosContainer = (props: any) => {
	
	let {refresh, setRefresh} = props;
	const api = new CostosAñoAdapter();
	const { exceptionError, resultError } = useNotifications();
	let [ejercicios, setEjercicios] = useState<any>([])
	let result: any;
  
  useEffect(()=>{
    getEjercicios();
	},[])

	useEffect(()=>{
		setRefresh && setRefresh(false);
	},[ejercicios])

	const getEjercicios = async () => {
		try {
			result = await api.ListarEjerciciosCostos();
			if(result.data && result.data!=="")
			{
				setEjercicios([ ...result.data ]);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};
	useEffect(()=>{
		if(refresh === true)
		{
			getEjercicios();
		}
	},[refresh])

  return <ComboEjercicios {...props} data={ejercicios}/>
};

export default ComboEjerciciosContainer;